export default [
  {
    key: "increasement",
    sortable: true,
    sortField: "createdAt",
    label: "label.no",
    thClass: "w-50px",
  },
  {
    key: "name",
    sortable: true,
    sortField: "firstName",
    label: "field.name",
    stickyColumn: true,
    variant: "light",
  },
  {
    key: "isActive",
    sortable: true,
    sortField: "isActive",
    label: "field.status",
  },
  {
    key: "bindTelegram",
    sortable: true,
    sortField: "bindTelegram",
    label: "field.bind_telegram",
  },
  {
    key: "email",
    sortable: true,
    sortField: "email",
    label: "field.email",
  },
  {
    key: "phone",
    sortable: true,
    sortField: "phone",
    label: "field.phone",
  },
  {
    key: "role",
    label: "field.role",
  },
  {
    key: "department",
    label: "field.department",
  },
  {
    key: "serviceCap",
    label: "general.chat_cap",
    variant: "center",
  },
  {
    key: "totalServiceCap",
    label: "field.serviceCap",
    variant: "center",
  },
  {
    key: "totalServiceWork",
    label: "general.total_service_work",
    variant: "center",
  },
  {
    key: "createdAt",
    sortable: true,
    sortField: "createdAt",
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
